import type { EngForm } from "./schema";

export const SUBMISSION_STATUSES = [
  "TRIAGING",
  "PASSED",
  "FLAGGED",
  "TICKET_QUEUED",
  "TICKET_CREATED",
  "TICKET_FAILED",
  "CLOSED_NO_TICKET",
] as const;
export type SubmissionStatus = (typeof SUBMISSION_STATUSES)[number];

export const TICKET_TYPES = ["Bug", "Customer Fix"] as const;
export type TicketType = (typeof TICKET_TYPES)[number];

export interface SubmissionMeta {
  id: string;
  kind: "eng";
  status: SubmissionStatus;
  statusChangedAt: string;
  createdAt: string;
  creatorEmail: string;
  creatorName: string;
  form: EngForm;
  // What the ticket will be raised as. Bug until triage classifies it; the creator can change it before the ticket is created.
  ticketType: TicketType;
  // What triage classified it as. Absent when triage was unavailable.
  aiTicketType?: TicketType;
  // True when the creator changed the type triage chose.
  ticketTypeCorrected?: boolean;
  // Set when the creator raised the ticket despite a "no ticket" triage verdict.
  overridden?: boolean;
  // What triage decided, kept here so the reports can count submissions that never became a ticket. Absent when triage was unavailable.
  triageVerdict?: "ticket_needed" | "not_needed";
  // Who closed it without a ticket: the creator, or the hourly sweep when nobody acted.
  closedBy?: "person" | "system";
  version: number;
}

// The meta fields a write can set alongside a status change.
export type MetaPatch = Partial<Pick<SubmissionMeta, "ticketType" | "aiTicketType" | "ticketTypeCorrected" | "overridden" | "triageVerdict" | "closedBy">>;

// Extra items stored under the same partition: triage results, acknowledgement, override, ticket checkpoints, audit events.
export interface StoredRecord {
  sk: string;
  data: Record<string, unknown>;
}

export interface User {
  email: string;
  name: string;
  isAdmin: boolean;
}

export type Job = { type: "triage"; id: string } | { type: "create-ticket"; id: string } | { type: "incident"; id: string };
